import { useMemo } from 'react';
import {
  EnhancedFieldConfig,
  FormSchemaConfig,
} from '../../types/form/schema.types';
import { FormState } from '../../types';
import {
  createCommentsTextarea,
  createGroupedApprovalSection,
  createRejectionTextarea,
  createStandardDisabledState,
  createYesNoRadio,
} from '../shared';
import { GIFT_HOSPITALITY_DONATION_SECTION_KEYS } from './constants';
import { shouldShowGiftHospitalityApproval } from './authoriserRules';

export const useGiftHospitalityDonationApprovalSchema = (
  formState: FormState
): FormSchemaConfig => {
  return useMemo<FormSchemaConfig>(() => {
    const sectionKey = GIFT_HOSPITALITY_DONATION_SECTION_KEYS.approval;
    if (!shouldShowGiftHospitalityApproval(formState.data)) {
      return { sections: [] };
    }

    const isDisabled = createStandardDisabledState(formState, sectionKey);

    const fields: EnhancedFieldConfig[] = [
        createYesNoRadio({
          name: 'approval_approve',
          label: 'Do you wish to authorise this request?',
          disabled: isDisabled,
          validationMessage: 'Please select yes or no',
        }),
        createRejectionTextarea({
          name: 'approval_rejection_details',
          label: 'Rejection Details',
          disabled: isDisabled,
          decisionField: 'approval_approve',
          validationMessage: 'Please enter the rejection details',
        }),
        createCommentsTextarea({
          name: 'approval_comments',
          label: 'Additional Comments',
          disabled: isDisabled,
          decisionField: 'approval_approve',
        }),

    ];

    return {
      sections: [
        createGroupedApprovalSection({
          title: 'Approval',
          fields,
        }),
      ],
      order: {
        priority: 2,
      },
    };
  }, [formState]);
};
